'use client';

import { useCommonAuthProvider } from '@modules/auth/providers/CommonAuthProvider/CommonAuthProvider';
import { CustomSpin } from '@modules/shared/components/CustomSpin';

import { Route } from 'next';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';

const IndexPage: React.FC = () => {
  const { login, isLoading, isAuthenticated } = useCommonAuthProvider();
  const router = useRouter();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated) {
      router.push('/organizations' as Route);

      return;
    }

    login();
  }, [isLoading, isAuthenticated, router, login]);

  return <CustomSpin />;
};

export default IndexPage;
